import { Box, Fade, SvgIcon } from '@material-ui/core';
/*
Remove this compoennt and replace with MUI's icons after MUI package update in future
*/
const FilterIcons = ({ isHovered = false, isFilterActive = false,toggleFilter, isSortingEnabled = false }) => {
  return (
    <Fade in={isHovered}>
      <Box sx={{
        display: 'flex',
        alignItems: 'center',
        position: 'absolute',
        right: isSortingEnabled ? 45 : 25
      }}
      onClick={toggleFilter}
      >
        {isFilterActive ? <SvgIcon>
          <path d="M4.25 5.61C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61"></path>
        </SvgIcon>
          :
          <SvgIcon>
            <path d="M7 6h10l-5.01 6.3zm-2.75-.39C6.27 8.2 10 13 10 13v6c0 .55.45 1 1 1h2c.55 0 1-.45 1-1v-6s3.72-4.8 5.74-7.39c.51-.66.04-1.61-.79-1.61H5.04c-.83 0-1.3.95-.79 1.61"></path>
          </SvgIcon>}
      </Box>
    </Fade>
  );
}

export default FilterIcons;
